import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
const MEILISEARCH_HOST = process.env.MIX_MEILISEARCH_HOST || (typeof window !== 'undefined' ? window.MEILISEARCH_HOST : undefined) || 'http://localhost:7700';
const MEILISEARCH_KEY = process.env.MIX_MEILISEARCH_KEY || (typeof window !== 'undefined' ? window.MEILISEARCH_KEY : undefined) || '';
/**
 * Get or create a unique user ID for analytics
 * Uses localStorage to persist across sessions
 */
function getMeilisearchUserId() {
    if (typeof window === 'undefined')
        return 'server';
    let userId = localStorage.getItem('meilisearch_user_id');
    if (!userId) {
        userId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('meilisearch_user_id', userId);
    }
    return userId;
}
const userId = getMeilisearchUserId();
export const searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_KEY, {
    // Meilisearch-specific options
    placeholderSearch: false,
    primaryKey: 'id',
    // Add custom headers for analytics tracking
    requestConfig: {
        headers: {
            'X-MS-USER-ID': userId,
        },
    },
}).searchClient;
